module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 41
// module chunks = 4220841425358 102538987983895 231608221292675